import { render, staticRenderFns } from "./button-top.vue?vue&type=template&id=46a0ffd0&"
import script from "./button-top.vue?vue&type=script&lang=js&"
export * from "./button-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports